import { useState, useSyncExternalStore } from "react";
import type { KioskDirectiveSource } from "../../../api/app-config";
import type { KioskRemoteLoginSource } from "../../../api/remote-login";
import { KioskUpdateController } from "../../../components/kiosk-update-controller";
import {
  getKioskBindingSnapshot,
  readLegacyKioskBinding,
  subscribeKioskBinding,
} from "../model/kiosk-binding";
import { KioskRemoteLoginController } from "./kiosk-remote-login-controller";

export function KioskRemoteRecoveryHost({
  directiveSource,
  remoteLoginSource,
}: {
  directiveSource?: KioskDirectiveSource;
  remoteLoginSource?: KioskRemoteLoginSource;
}) {
  const binding = useSyncExternalStore(
    subscribeKioskBinding,
    getKioskBindingSnapshot,
  );
  // Capture the deployed URL before KioskPage canonicalizes browser history to
  // `/`. This keeps legacy kiosks enrolled in remote updates even while their
  // authenticated binding migration is still retrying.
  const [legacyBinding] = useState(() => readLegacyKioskBinding());
  const updateTarget = binding ?? legacyBinding;

  if (!updateTarget) return null;

  return (
    <>
      <KioskUpdateController
        storeKey={updateTarget.storeKey}
        zoneId={updateTarget.zoneId}
        directiveSource={directiveSource}
      />
      {binding && (
        <KioskRemoteLoginController
          binding={binding}
          source={remoteLoginSource}
        />
      )}
    </>
  );
}
